export default __webpack_public_path__ + "static/media/smiley-text-gray.05611ae9.svg";